var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuickshipArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 76"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 25,
    cy: 25,
    r: 25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow 3",
    d: "M24.2929 41.7071C24.6834 42.0976 25.3166 42.0976 25.7071 41.7071L32.0711 35.3431C32.4616 34.9526 32.4616 34.3195 32.0711 33.9289C31.6805 33.5384 31.0474 33.5384 30.6569 33.9289L25 39.5858L19.3431 33.9289C18.9526 33.5384 18.3195 33.5384 17.9289 33.9289C17.5384 34.3195 17.5384 34.9526 17.9289 35.3431L24.2929 41.7071ZM24 10L24 41L26 41L26 10L24 10Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickshipArrowDown);
export default __webpack_public_path__ + "static/media/quickshipArrowDown.b6ecc2ce30aec41b4ca6a046ed8cdb62.svg";
export { ForwardRef as ReactComponent };